import React from 'react';

export const renderSocialLink = (
  type: 'linkedin' | 'telegram' | 'whatsapp' | 'github' | 'twitter' | 'dribbble',
  url: string,
  displayFormat?: 'alias' | 'logo' | 'url' | 'logo_alias',
  onFieldClick?: (fieldName: string) => void,
  activeField?: string | null
) => {
  const format = displayFormat || 'alias';
  const fieldName = type;

  const getAlias = () => {
    switch (type) {
      case 'linkedin':  return 'LinkedIn';
      case 'telegram':  return 'Telegram';
      case 'whatsapp':  return 'WhatsApp';
      case 'github':    return 'GitHub';
      case 'twitter':   return 'Twitter';
      case 'dribbble':  return 'Dribbble';
      default:          return '';
    }
  };

  const stripProtocol = (u: string) => u.replace(/^https?:\/\//, '');
  const content = format === 'url' ? stripProtocol(url) : getAlias();

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', color: 'inherit' }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onFieldClick?.(fieldName);
      }}
    >
      {content}
    </a>
  );
};
